export default __webpack_public_path__ + "static/media/SE100.a45a4f8e.gif";